import { TimeFormatOptions } from '@griply/types';
import { format } from 'date-fns';

import { MS_PER_DAY } from './utc-day';

const MS_PER_HOUR = 60 * 60 * 1000;
const MS_PER_MINUTE = 60 * 1000;

// Without a timeFormat this stays the raw 24h clock (what the pickers show). Pass the
// user's TimeFormatOptions wherever the value is user-facing, so 12h accounts read
// "2:30 PM" on both platforms instead of mobile silently rendering 24h.
export const formatTimeOfDay = (
  msSinceMidnight: number | null,
  timeFormat?: TimeFormatOptions,
): string | null => {
  if (msSinceMidnight === null) {
    return null;
  }
  if (msSinceMidnight < 0 || msSinceMidnight >= MS_PER_DAY) {
    return null;
  }
  const hours = Math.floor(msSinceMidnight / MS_PER_HOUR);
  const minutes = Math.floor((msSinceMidnight % MS_PER_HOUR) / MS_PER_MINUTE);

  if (timeFormat) {
    // a local date so date-fns renders the same wall clock it was handed
    return format(new Date(1970, 0, 1, hours, minutes), timeFormat);
  }

  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};
